import { Component, OnInit } from '@angular/core';
import { ButtonType, INzMessageType } from '@ascschool/interface/setting';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { UserFuntionService } from '@ascschool/services/user/user-funtion.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzContextMenuService, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { NzFormatEmitEvent, NzTreeNode } from 'ng-zorro-antd/tree';

export interface nodesData {
  title: string;
  expanded: boolean;
  groupId: number;
  id: number;
  isUser: boolean;
  children: nodesData[] | null;
  isLeaf?: boolean;
  key: string;
  ptaId?: string;
  name?: string;
}
export interface TreeNodeInterface {
  key: string;
  screenName: string;
  allowCreate?: boolean;
  allowCreateVisible?: boolean;
  allowCustom?: boolean;
  allowCustomVisible?: boolean;
  allowDelete?: boolean;
  allowDeleteVisible?: boolean;
  allowRead?: boolean;
  allowReadVisible?: boolean;
  allowUpdate?: boolean;
  allowUpdateVisible?: boolean;
  id?: number;
  parentId?: string;
  expand?: boolean;
  level?: number;
  child?: TreeNodeInterface[];
  parent?: TreeNodeInterface;
  screenId?: number;
}
export enum AllowType {
  AllowRead = 'allowRead',
  AllowCreate = 'allowCreate',
  AllowUpdate = 'allowUpdate',
  AllowDelete = 'allowDelete',
  AllowCustom = 'allowCustom'
}
@Component({
  selector: 'app-phan-quyen-chuc-nang',
  templateUrl: './phan-quyen-chuc-nang.component.html',
  styleUrls: ['./phan-quyen-chuc-nang.component.scss']
})
export class PhanQuyenChucNangComponent implements OnInit {
  get breadcrumbs(): string[] {
    return ['Quản trị hệ thống'];
  }
  constructor(
    private nzContextMenuService: NzContextMenuService,
    private authQuery: AuthQuery,
    private service: UserFuntionService,
    public utilsService: UtilsService
  ) {}
  allowChange = AllowType;
  isUser: boolean;
  selectedInheritanceRightsOption: any = 0;
  selectedAddNewPermissionsOption: any = 0;
  btnType: ButtonType;
  buttonTypeEnum = ButtonType;
  searchValue = '';
  dataTransfers = [];
  defaultSelectedKeys: any;
  // activated node
  activatedNode?: NzTreeNode;
  nodes: nodesData[] = [];
  listOfMapData: TreeNodeInterface[] = [];
  mapOfExpandedData: { [key: string]: TreeNodeInterface[] } = {};
  theTreeSave = [];
  id: number;
  groupId: number;
  settingValueLoading = false;
  checked = false;
  setOfCheckedId = new Set<number>();
  ngOnInit() {
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });

    // this.changeTreeList(this.dataTransfers);
    this.initializationValues();
  }
  list_to_tree(list: any[]) {
    // tslint:disable-next-line: one-variable-per-declaration
    let map = {},
      node,
      roots = [],
      i;
    for (i = 0; i < list.length; i += 1) {
      map[list[i].screenId] = i; // initialize the map
      if (list.some((c) => c.parentId === list[i].screenId)) {
        list[i].child = []; // initialize the children
      }
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parentId !== 0) {
        // if you have dangling branches check that map[node.ptaId] exists
        list[map[node.parentId]].child.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
  changeTreeList(list: any) {
    this.nodes = this.list_to_tree(list);
  }
  openFolder(data: NzTreeNode | NzFormatEmitEvent): void {
    // do something if u want
    if (data instanceof NzTreeNode) {
      data.isExpanded = !data.isExpanded;
    } else {
      const node = data.node;
      if (node) {
        node.isExpanded = !node.isExpanded;
      }
    }
  }
  activeNode(data: NzFormatEmitEvent): void {
    // tslint:disable-next-line: no-non-null-assertion
    this.activatedNode = data.node!;
    const value = this.activatedNode.origin;
    this.getPermission(value.id, value.groupId, value.isUser);
    this.isUser = value.isUser;
    this.groupId = value.groupId;
    this.id = value.id;
  }
  contextMenu($event: MouseEvent, menu: NzDropdownMenuComponent): void {
    this.nzContextMenuService.create($event, menu);
  }
  selectDropdown(): void {
    // do something
  }
  nzEvent(event: NzFormatEmitEvent): void {
    // console.log(event);
  }
  collapse(array: TreeNodeInterface[], data: TreeNodeInterface, $event: boolean): void {
    if (!$event) {
      if (data.child) {
        data.child.forEach((d) => {
          const target = array.find((a) => a.screenId === d.screenId)!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    }
  }
  convertTreeToList(root: TreeNodeInterface): TreeNodeInterface[] {
    const stack: TreeNodeInterface[] = [];
    const array: TreeNodeInterface[] = [];
    const hashMap = {};
    stack.push({ ...root, level: 0, expand: false });
    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.child) {
        for (let i = node.child.length - 1; i >= 0; i--) {
          stack.push({ ...node.child[i], level: node.level! + 1, expand: false, parent: node });
        }
      }
    }
    return array;
  }
  visitNode(
    node: TreeNodeInterface,
    hashMap: { [key: string]: boolean },
    array: TreeNodeInterface[]
  ): void {
    if (!hashMap[node.screenName]) {
      hashMap[node.screenName] = true;
      array.push(node);
    }
  }

  initializationValues() {
    this.service.getTreeGroupByUser().subscribe((resp) => {
      this.nodes = resp;
      this.defaultSelectedKeys = this.nodes[0].key;
      this.getPermission(this.nodes[0].id, this.nodes[0].groupId, this.nodes[0].isUser);
      this.id = this.nodes[0].id;
      this.groupId = this.nodes[0].groupId;
      this.isUser = this.nodes[0].isUser;
    });
  }

  getPermission(id: number, groupId: number, isUser: boolean) {
    if (id != null && groupId != null) {
      this.service.getPermission(id, groupId, isUser).subscribe((resp: any[]) => {
        this.listOfMapData = this.list_to_tree(resp);
        this.theTreeSave = [];
        this.listOfMapData.forEach((item) => {
          this.mapOfExpandedData[item.screenId] = this.convertTreeToList(item);
          this.pushToTreeSave(item);
          if (item.child) {
            this.pustTotreeBefore(item.child);
          }
        });
      });
    }
  }

  pustTotreeBefore(resp: any[]): void {
    resp.forEach((item) => {
      this.pushToTreeSave(item);
    });
  }

  addToTreeSave(item, allowtype: AllowType) {
    let param: string;
    let allowtypeAct: any;
    switch (allowtype) {
      case AllowType.AllowRead:
        param = 'allowRead';
        allowtypeAct = item.allowRead;
        break;
      case AllowType.AllowCreate:
        param = 'allowCreate';
        allowtypeAct = item.allowCreate;
        break;
      case AllowType.AllowUpdate:
        param = 'allowUpdate';
        allowtypeAct = item.allowUpdate;
        break;
      case AllowType.AllowDelete:
        param = 'allowDelete';
        allowtypeAct = item.allowDelete;
        break;
      case AllowType.AllowCustom:
        param = 'allowCustom';
        allowtypeAct = item.allowCustom;
        break;
    }
    this.updateChildArray(
      this.theTreeSave.filter((q) => q.screenId === item.screenId),
      param,
      allowtypeAct
    );
    if (item.child) {
      this.updateChildArray(item.child, param, allowtypeAct);
      this.updateChildArray(
        this.theTreeSave.filter((q) => q.parentId === item.screenId),
        param,
        allowtypeAct
      );
      this.updateMappingItem(item.screenId, param, allowtypeAct);
    }
  }

  pushToTreeSave(item: any): void {
    this.theTreeSave.push({
      screenId: item.screenId,
      screenName: item.screenName,
      allowRead: item.allowRead,
      allowReadVisible: item.allowReadVisible,
      allowCreate: item.allowCreate,
      allowCreateVisible: item.allowCreateVisible,
      allowUpdate: item.allowUpdate,
      allowUpdateVisible: item.allowUpdateVisible,
      allowDelete: item.allowDelete,
      allowDeleteVisible: item.allowDeleteVisible,
      allowCustom: item.allowCustom,
      allowCustomVisible: item.allowCustomVisible,
      id: item.id,
      parentId: item.parentId
    });
  }

  updateChildArray(child: any[], param: string, vaule: any): void {
    this.updateValueBool(child, param, vaule);
  }

  updateMappingItem(screenId: any, param: string, vaule: any): void {
    const target = this.mapOfExpandedData[screenId];
    if (target) {
      this.updateValueBool(target, param, vaule);
    }
  }

  updateValueBool(arrayU: any[], param: string, vaule: any): void {
    arrayU.map((todo, i) => {
      arrayU[i][param] = vaule;
    });
  }
  /* 1. END Xu ly update khi check chon END */

  save() {
    if (this.theTreeSave) {
      this.settingValueLoading = true;
      this.service
        .putUserFuntions(
          {
            Id: this.id,
            GroupId: this.groupId,
            IsUser: this.isUser,
            InheritanceType: this.selectedInheritanceRightsOption,
            AdditionalType: this.selectedAddNewPermissionsOption
          },
          this.theTreeSave
        )
        .subscribe((resp: any) => {
          this.utilsService.notifyResponse({ statusCode: resp.status, message: resp.message });
          setTimeout(() => {
            this.settingValueLoading = false;
          }, 500);
        });
    } else {
      this.utilsService.showNotification(INzMessageType.Warning, 'Không có dữ liệu thay đổi');
    }
  }

  onAllChecked(checked: boolean): void {}

  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
}
